import { createAction } from "redux-actions";
import { GET_QUESTIONS_BY_USER, CREATE_QUESTIONS_BY_USER } from "../constants";
import { serverFindData } from "../services/crud";
import { feathersCreateData } from "../services";

export const findQuestionsByUser = createAction(GET_QUESTIONS_BY_USER, (query) => serverFindData('usersquestions-company', query)())
export const createQuestionsByUser = createAction(CREATE_QUESTIONS_BY_USER, (data) => feathersCreateData('process-user-question', data)())

